import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const UsoCFDIService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Uso_CFDI_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_uso_cfdi: null,
			uso_cfdi: form.uso_cfdi,
			descripcion: form.descripcion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Uso_CFDI_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_uso_cfdi: form.id_cat_uso_cfdi,
			uso_cfdi: form.uso_cfdi,
			descripcion: form.descripcion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Uso_CFDI_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_uso_cfdi) => {
		let params = {
			id_cat_uso_cfdi: id_cat_uso_cfdi
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Uso_CFDI_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
